import { useContext } from 'react';
import { HookContext, type HookContextValue } from './HookProvider';

export function useHook(): HookContextValue {
  const ctx = useContext(HookContext);
  if (ctx === undefined) {
    throw new Error('useHook must be used inside <HookProvider>');
  }
  return ctx;
}
